/**
 * Created by Jession on 2018/04/13.
 * 应付记录（核销功能）
 */
import React from 'react';
import {hashHistory} from 'react-router';
import {
    Form,
    Input,
    Button,
    Row,
    Col,
    DatePicker,
    Select,
    Table,
    Upload,
    message,
    Icon,
    Modal,
    InputNumber
} from 'antd';
import moment from 'moment';
import {DmsTab, DisplayForm, TableView} from 'Components';
import {openNotice} from 'Utils';
import ProductModal from '../inventory/productModal';
import {orderWritenoffList, riskWritenoff, getPaymentDetail} from '../../service/financialMgm';

const FormItem = Form.Item;

class PaymentEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [],
            salesRowKeys: [], // 销售订单列表选择
            opts: ['应付核销'],
            btnLoad: false,
            detail: {
                productId: '',
                price: ''
            },
            endOpen: false, // 控制失效时间选择
            // promotionActivityType: [
            //     {key: 0, sKey: 0, name: '对公转账'},
            //     {key: 1, sKey: 1, name: '现金'},
            //     {key: 2, sKey: 2, name: '支票'},
            //     {key: 3, sKey: 3, name: '支付宝'},
            //     {key: 4, sKey: 4, name: '微信'},
            //     {key: 5, sKey: 5, name: '其他'}
            // ],
            rows: [
                // {"id":-1,"code":"201801100001","cusName":"测试的，不要删","orderDate":"2018-01-17 20:13:41","amount":10000.00,"writenoffCount":0.00,"unWritenoffCount":10000.00},
                // {"id":4,"code":"201801100003","cusName":"WJL_荆轲","orderDate":"2017-12-04 20:13:48","amount":298.00,"writenoffCount":0.00,"unWritenoffCount":298.00},
                // {"id":5,"code":"201801100004","cusName":"WJL_亚瑟","orderDate":"2018-02-06 20:13:56","amount":298.00,"writenoffCount":0.00,"unWritenoffCount":298.00},
                // {"id":6,"code":"201801100005","cusName":"WJL_项羽","orderDate":"2017-12-13 20:14:00","amount":298.00,"writenoffCount":0.00,"unWritenoffCount":298.00},
                // {"id":7,"code":"201801100006","cusName":"WJL_老夫子","orderDate":"2017-12-11 20:14:08","amount":298.00,"writenoffCount":0.00,"unWritenoffCount":298.00}
            ], // 展示筛选后的核销订单
            deleteRows: [], // 已选择的核销订单(准备删除的订单)
            salesRows: [],  // 销售单列表
            selectedRows: [],  // 已选择还未确定的销售单
            total: 1,
            searchObj: {  // 选择销售单
                orderDateStart: '',
                orderDateEnd: '',
                code: '',
                ids: [],
                s: 10,
                p: 1
            },
            baseSearchObj: {
                id: '',
                s: 10,
                p: 1
            },
            visible: false,
            totalAmount: 0 // 本次核销金额汇总
        }
    }

    goBack = () => {
        hashHistory.goBack();
    };

    disabledStartDate = (startValue) => {
        const endValue = this.state.searchObj.orderDateEnd;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }
    disabledEndDate = (endValue) => {
        const startValue = this.state.searchObj.orderDateStart;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }
    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({endOpen: true});
        }
    }
    handleEndOpenChange = (open) => {
        this.setState({endOpen: open});
    }

    /* 搜索时间选择 */
    handleChoseTime(tag, times) {
        // console.log(tag);
        // console.log(moment(times).format('YYYY-MM-DD HH:mm:ss'));
        let _obj = {}
            , _name = ''
        ;
        if (tag == "start") {
            _name = 'orderDateStart';
        } else {
            _name = 'orderDateEnd';
        }
        _obj[_name] = times;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                ..._obj
            }
        }, () => {
            // console.log(this.state.searchObj);
        });
    }

    /* 清除时间 */
    clearTime() {
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                orderDateStart: '',
                orderDateEnd: '',
                s: 10,
                p: 1
            }
        })
    }

    /* 提交 */
    submitFn() {
        // console.log(this.state.rows);
        let _rows = [...this.state.rows]
            , _info = this.props.location.state
            , _unCount = _info.writenoffCountAble // 可核销金额
            , _param = {
            id: _info.id,
            writenoffCountCur: this.state.totalAmount,
            tgTransWritenoffs: []
        };
        if (!_rows.length) {
            message.warning('请添加核销订单');
            return;
        } else if (this.state.totalAmount > _unCount) {
            message.warning('本次核销金额汇总不能大于可核销金额');
            return;
        } else {
            _param.tgTransWritenoffs = _rows.map(x => {
                return {
                    orderId: x.id,
                    writenoffCountCur: x.curAmount || 0
                }
            });
        }
        // console.log(_param);
        /* 应付记录核销提交 */
        riskWritenoff(_param).then(res => {
            if (res.status && res.code == 200) {
                openNotice('success', '提交成功', '');
                this.goBack();
            } else {
                openNotice('error', '提交失败', (res && res.message) ? res.message : '');
            }
        });
    }

    /* 确认销售单选择 */
    handleOk = () => {
        this.clearTime();
        // console.log(this.state.selectedRows);
        this.setState({
            visible: false,
            rows: [...this.state.rows, ...this.state.selectedRows],
            salesRowKeys: [],
            selectedRows: []
        });
    }

    /* 核销金额变动 */
    changeAmount(eq, record, val) {
        /*console.log(eq);
        console.log(record);
        console.log(xxx);*/
        // console.log(this.state.totalAmount)  // 本次核销总金额
        // console.log(this.props.location.state.unWritenoffCount) // 订单未核销金额
        // console.log(record.unWritenoffCount) // 当前选择订单未核销金额
        let rows = [...this.state.rows]
            , totalAmount = 0;
        ;
        rows[eq].curAmount = val;
        // console.log(this.state.rows);
        rows.map(x => {
            totalAmount += (x.curAmount || 0);
        });
        // console.log(totalAmount);
        this.setState({rows, totalAmount});
    }

    /* 取消销售单选择 */
    handleCancel = () => {
        this.clearTime();
        this.setState({
            visible: false,
            salesRowKeys: [],
            selectedRows: []
        });
    }

    /* 新增（显示销售单列表） */
    addHandler = (event) => {
        // orderWritenoffList().then(res => {});
        // console.log(this.state. );
        this.getOrderWritenoffList();
        this.setState({visible: true});
    }
    /* 删除选中的核销订单 */
    deleteFn = (event) => {
        let rows = [...this.state.rows];
        if (!this.state.selectedRowKeys.length) {
            message.warning('请选择删除项');
            return;
        }
        this.state.selectedRowKeys.map(x => {
            rows.map((items, index) => {
                if (x == items.id) {
                    rows.splice(index, 1);
                }
            });
        });
        this.setState({rows, selectedRowKeys: []}, () => {
            openNotice('success', '删除成功', '');
        });
    }

    /* 获取销售单列表 */
    getOrderWritenoffList() {
        let _obj = this.state.searchObj
            , _start = _obj.orderDateStart ? moment(_obj.orderDateStart).format('YYYY-MM-DD') + ' 00:00:00' : ''
            , _end = _obj.orderDateEnd ? moment(_obj.orderDateEnd).format('YYYY-MM-DD') + ' 23:59:59' : ''
            , _rows = this.state.rows
            , ids = [-1] // ids不能为空数组，或者不传ids,所以默认-1
        ;
        _rows.map(x => {
            ids.push(x.id);
        });
        orderWritenoffList({
            ..._obj,
            ids,
            orderDateStart: _start,
            orderDateEnd: _end,
        }).then(res => {
            // console.log(res);
            this.setState({salesRows: res.data, total: res.total});
        });
    }

    /* 销售单列表分页 */
    pageChange(page, pageSize) {
        // console.log(page);
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                s: pageSize,
                p: page
            }
        }, () => {
            this.getOrderWritenoffList();
        })
    }

    /* 核销订单选择列表(用作删除) */
    onSelectChange = (selectedRowKeys, deleteRows) => {
        this.setState({selectedRowKeys, deleteRows});
    };

    /* 销售单选择列表 */
    onSalesChange(salesRowKeys, selectedRows) {
        // console.log(salesRowKeys);
        // console.log(selectedRows);
        this.setState({salesRowKeys, selectedRows});
    }

    /*获取详情数据*/
    initData() {
        // this.state.searchObj.id = this.state.paySearchObj.riskId = this.props.routeParams.id;
        var obj = this.state.baseSearchObj;
        getPaymentDetail(obj).then(result => {
            if (result.status) {
                let detail = JSON.parse(JSON.stringify(result.data));
                // console.log(detail);
                // delete detail.writenoffDetailVos;
                this.setState({
                    // rows: detail.tgTransWritenoffs || [],
                    // total: result.total,
                    detail: detail
                });
            } else {
                message.error(result.message);
            }
        })
    }

    componentDidMount() {
        this.setState({
            baseSearchObj: {
                ...this.state.baseSearchObj,
                id: this.props.routeParams.id
            }
        }, () => {
            this.initData();
        });
        // this.initData();
        // console.log(this);
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    orderNumberChange(event) {
        // console.log(event.target.value)
        this.setState({searchObj: {...this.state.searchObj, code: event.target.value}});
    }

    render() {
        const {opts, detail, promotionActivityType, btnLoad, endOpen, rows, total, searchObj, salesRows, visible, selectedRowKeys, salesRowKeys, totalAmount} = this.state;
        // const infos = this.props.location.state;
        const props = {
            name: 'file',
            action: '//jsonplaceholder.typicode.com/posts/',
            headers: {
                authorization: 'authorization-text',
            },
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    message.success(`${info.file.name} file uploaded successfully`);
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };
        let self = this;
        const tableViewProps = {  // 核销订单列表
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: 1,
                current: 1,//当前页码
                pageSize: 1,//当前分页数
                onChange: e => {
                }
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'record',
                    render: (text, record, index) => {
                        let _index = (this.state.searchObj.p - 1) * this.state.searchObj.s + index + 1;
                        return _index;
                    }
                }, {
                    title: '订单号',
                    dataIndex: 'code'
                },
                {
                    title: '订单时间',
                    dataIndex: 'orderDate'
                },
                {
                    title: '订单金额',
                    dataIndex: 'amount',
                    render: (text, record, index) => {
                        return record.amount.toFixed(2);
                    }
                },
                {
                    title: '已核销金额',
                    dataIndex: 'writenoffCount',
                    render: (text, record, index) => {
                        return record.writenoffCount.toFixed(2);
                    }
                },
                {
                    title: '未核销金额',
                    dataIndex: 'unWritenoffCount',
                    render: (text, record, index) => {
                        return record.unWritenoffCount.toFixed(2);
                    }
                },
                {
                    title: '本次核销金额',
                    dataIndex: 'curAmount',
                    render: (text, record, index) => {
                        // return <Input style={{width:150}}/>
                        // return <InputNumber min={0} max={record.unWritenoffCount} onChange={this.changeAmount.bind(this, index, record)} />
                        return <InputNumber min={0} max={record.unWritenoffCount} type='number'
                                            onChange={this.changeAmount.bind(this, index, record)}/>
                    }
                }
            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: self.onSelectChange
            }
        };

        const displayData = [
            {label: '编号', value: detail.riskCode},
            {label: '应付日期', value: new Date(detail.riskDate).format('yyyy-MM-dd')},
            {label: '费用类型', value: detail.riskType},
            {label: '客户名称', value: detail.cusName},
            {label: '应付金额', value: detail.riskCountShould || 0},
            {label: '已付金额', value: detail.riskCountReal},
            {label: '已核销订单金额', value: detail.writenoffCount},
            {label: '可核销金额', value: detail.writenoffCountAble},
            {
                label: '收款凭证', value: detail.attachmentDto || [], type: 'attachList', clickFn: function (item) {
                    console.log(item);
                }
            }
        ];

        const salesProps = {  // 销售单列表
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange.bind(this)
            },
            columns: [
                {
                    title: '订单号',
                    dataIndex: 'code'
                },
                {
                    title: '订单日期',
                    dataIndex: 'orderDate'
                },
                {
                    title: '订单金额',
                    dataIndex: 'amount',
                    render: (text, record, index) => {
                        return record.amount.toFixed(2);
                    }
                },
                {
                    title: '已核销金额',
                    dataIndex: 'writenoffCount',
                    render: (text, record, index) => {
                        return record.writenoffCount.toFixed(2);
                    }
                },
                {
                    title: '未核销金额',
                    dataIndex: 'unWritenoffCount',
                    render: (text, record, index) => {
                        return record.unWritenoffCount.toFixed(2);
                    }
                }],
            rows: salesRows,
            rowSelection: {
                selectedRowKeys: salesRowKeys,
                onChange: this.onSalesChange.bind(this)
            }
        }
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                <Button type='primary' loading={btnLoad} onClick={this.submitFn.bind(this)}>提交</Button>
                <Button onClick={this.goBack}>取消</Button>
            </DmsTab>
            <div className="dms-table-box">
                <DisplayForm dataSource={displayData} perRow="2"/>
                <div>
                    <DmsTab className="white-bg no-border" options={['核销订单']} defaultKey={0}/>
                    <div className="dms-table-box">
                        <div className="dms-table-head">
                            <Button onClick={this.addHandler}>新增</Button>
                            <Button style={{marginLeft: 10}} onClick={this.deleteFn}>删除</Button>
                        </div>
                        <TableView {...tableViewProps}/>
                        <p>本次核销金额汇总：{totalAmount}</p>
                    </div>
                </div>
            </div>

            <Modal
                visible={visible}
                title="选择销售单"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={800}
            >
                <div>
                    <Row style={{marginBottom: 10}}>
                        <Col>
                            <label>订单号：</label>
                            <Input onChange={this.orderNumberChange.bind(this)} style={{width: 130}}/>
                            <label style={{marginLeft: 10}}>订单日期：</label>
                            <DatePicker
                                showTime={false}
                                disabledDate={this.disabledStartDate}
                                onChange={this.handleChoseTime.bind(this, 'start')}
                                onOpenChange={this.handleStartOpenChange}
                                style={{marginLeft: 10}}/>
                            <span style={{marginLeft: 10}}>至</span>
                            <DatePicker
                                showTime={false}
                                disabledDate={this.disabledEndDate}
                                onChange={this.handleChoseTime.bind(this, 'end')}
                                onOpenChange={this.handleEndOpenChange}
                                open={endOpen}
                                style={{marginLeft: 10}}/>
                            <Button style={{marginLeft: 50}} onClick={this.getOrderWritenoffList.bind(this)}>搜索</Button>
                        </Col>
                    </Row>
                    <TableView {...salesProps} />
                </div>

            </Modal>

        </div>
    }
};
export default PaymentEdit;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/paymentEdit.js